import { useEffect, useState } from 'react';

export const MOBILE_WIDTH = 768;

const defaultDimensions = {
    width: 0,
    height: 0,
    isMobile: false,
};

export function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(defaultDimensions);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);

        function getWindowDimensions() {
            return {
                width: window.innerWidth,
                height: window.innerHeight,
                isMobile: window.innerWidth <= MOBILE_WIDTH,
            };
        }

        setWindowDimensions(getWindowDimensions());

        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isClient ? windowDimensions : defaultDimensions;
}
